module.exports = __webpack_public_path__ + "v1.8.4.20261010/img/006.c28dffd5.png";